module.exports = __webpack_public_path__ + "static/media/campo3.114998e6.jpg";